export default __webpack_public_path__ + "static/media/ecORBy2.e21b221f.jpg";